import { render, staticRenderFns } from "./Audio.vue?vue&type=template&id=455ebf3a&scoped=true&"
import script from "./Audio.vue?vue&type=script&lang=ts&"
export * from "./Audio.vue?vue&type=script&lang=ts&"
import style0 from "./Audio.vue?vue&type=style&index=0&id=455ebf3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455ebf3a",
  null
  
)

export default component.exports